import { useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import Comment from './Comment';
import { CommentsContainer } from './Comments';

const ReplyCount = styled('div', {
  shouldForwardProp: (prop) => prop !== 'show',
})(({ show }) => ({
  fontSize: '14px',
  lineHeight: '18px',
  padding: '0 0 16px 40px',
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Fjalla One',
  fontWeight: '400',
  color: '#000000',
  cursor: 'pointer',
  width: 'fit-content',
  '& svg': {
    marginRight: '3px',
    transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));

const RepliesOfComment = ({ noteId, noteAuthorId, childComments, parentId, replyComment }) => {
  const [showReply, setShowReply] = useState(false);

  const repliesCount = childComments.filter((ele) => ele.parentCommentId === parentId).length;
  const RepliesDisplay = () => {
    return repliesCount > 0 ? (
      <ReplyCount
        onClick={() => {
          setShowReply(!showReply);
        }}
        show={showReply}
      >
        <ArrowDropDownRoundedIcon />
        {repliesCount} {repliesCount > 1 ? 'Replies' : 'Reply'}
      </ReplyCount>
    ) : (
      ''
    );
  };

  return (
    <>
      <RepliesDisplay />
      {showReply && (
        <CommentsContainer>
          {childComments.map((child) => {
            if (child.parentCommentId === parentId) {
              return (
                <li key={child.id}>
                  <Comment
                    noteId={noteId}
                    noteAuthorId={noteAuthorId}
                    commentId={child.id}
                    commentProps={child}
                    isParent={false}
                    replyComment={replyComment}
                  >
                    {child.text}
                  </Comment>
                </li>
              );
            }
          })}
        </CommentsContainer>
      )}
    </>
  );
};
export default RepliesOfComment;
